/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { AuthAmplifyService } from 'src/app/shared/service/auth-amplify.service';
import { AuthenticationService } from 'src/app/shared/service/authentication.service';
import { SharingDataService } from 'src/app/shared/service/sharing-data.service';
import { TranslationService } from 'src/app/shared/service/translation.service';
import { Router } from '@angular/router';
import { StoreManagerService } from 'src/app/shared/store-manager/services/store-manager.service';
import { MainNavComponent } from '../main-nav/main-nav.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [MainNavComponent],
})
export class HeaderComponent implements OnInit {
  isMenuVisible: boolean = false;
  scrolled60: any;
  above60: boolean = false
  aliasSelected: any;
  loggedInUser: Observable<any>;
  activeLink: string = 'events'

  selectedLanguage: string;

  isMobileMenuVisible: boolean = false;
  isProfileVisible: boolean = false
  private readonly destroyRef = inject(DestroyRef);
  translationData: any;
  allSupportedLangCodes: any[];

  private readonly _authenticationService = inject(AuthenticationService);
  private readonly _authAmplifyService = inject(AuthAmplifyService);
  private readonly _sharingData = inject(SharingDataService);
  private readonly _translationService = inject(TranslationService);
  private readonly _router = inject(Router);
  private readonly _storeManagerService = inject(StoreManagerService);

  constructor() {
    this.loggedInUser = this._authenticationService.isLoggedIn();
    this.allSupportedLangCodes = this._translationService.getSupportedLanguageByCode();
    const selectedLanguage = this._storeManagerService.getUserSelectedLanguageFromStore();
    this.selectedLanguage = selectedLanguage;
  }


  ngOnInit(): void {
    this._storeManagerService.setMapDataOnLoad(<any>null)

    this._sharingData.getAliasList().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data) {
        this.aliasSelected = data;
      }
    });

    this._sharingData.getMobileMenuStatus().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      this.isMobileMenuVisible = data;
    });

    this._sharingData.getProfileDetailsClicked().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value: any) => {
      if (value) {
        this.isProfileVisible = false
      }
    });

    localStorage.getItem('profile');
    if (localStorage.getItem('profile')) {
      this.aliasSelected = true;
    }

  }



  async logout() {
    this.removeIndexedDb();
    this._authAmplifyService.proxyLogin().subscribe((response: { data: string; }) => {
      window.location.href = response.data;
    });
  }
  async removeIndexedDb() {
    const dbs = await window.indexedDB.databases()
    dbs.forEach((db: any) => { window.indexedDB.deleteDatabase(db.name) })
    this.toggleMobileMenu(); // menu should be hidden
  }

  switchLanguage(language: string) {
    this._storeManagerService.setUserLanguageToStore(language);
    const fullURL = window.location.href.split('/');
    fullURL[3] = language;
    window.location.href = fullURL.join('/');
  }

  toggleMobileMenu() {
    this._sharingData.setMobileMenuStatus(!this.isMobileMenuVisible);
  }
  myProfile() {
    this.isProfileVisible = !this.isProfileVisible
  }
  closeDialog(event: any) {
    event.stopPropagation()
    this._sharingData.setProfileSelected(true)
    this.isProfileVisible = false
  }

  logoClicked() {
    this._router.navigate(['/events'])
  }
}
